export const OPEN_MODAL = 'modals/OPEN_MODAL';
export const OPEN_MODAL_READY = 'modals/OPEN_MODAL [ready]';

export const OPEN_ERROR_MODAL = 'modals/OPEN_ERROR_MODAL';

export const CLOSE_MODAL = 'modals/CLOSE_MODAL';
export const CLOSE_MODAL_READY = 'modals/CLOSE_MODAL [ready]';
